// 설정: the open workbook (name, who sees it), budgets, items and CSV, how
// the app looks on this device, and signing out (of tensor only: each app
// signs in on its own, design 00 4.2).
import { useState } from 'react'

import { errorText } from '../../api/client'
import { FONT_SIZES, type FontSize, applyFontSize, fontSize } from '../../lib/fontSize'
import { THEMES, type Theme, applyTheme, theme } from '../../lib/theme'
import { ErrorText } from '../../ui/common'
import { navigate } from '../../ui/router'
import { engine } from '../engine'
import { useT } from '../store'
import type { Current } from './common'
import { WorkbookSettings } from './Workbooks'

function Display() {
  const [size, setSize] = useState<FontSize>(fontSize)
  const [look, setLook] = useState<Theme>(theme)
  return (
    <section className="card">
      <h3>화면</h3>
      <fieldset className="radio-row">
        <legend>테마</legend>
        {THEMES.map((t) => (
          <label key={t.value} className="radio-choice">
            <input
              type="radio"
              name="theme"
              value={t.value}
              checked={look === t.value}
              onChange={() => {
                setLook(t.value)
                applyTheme(t.value, true)
              }}
            />
            {t.label}
          </label>
        ))}
      </fieldset>
      <fieldset className="radio-row">
        <legend>글자 크기</legend>
        {FONT_SIZES.map((f) => (
          <label key={f.value} className="radio-choice" style={{ fontSize: `${f.px}px` }}>
            <input
              type="radio"
              name="font-size"
              value={f.value}
              checked={size === f.value}
              onChange={() => {
                setSize(f.value)
                applyFontSize(f.value, true)
              }}
            />
            {f.label}
          </label>
        ))}
      </fieldset>
      <p className="muted small">이 기기에만 적용됩니다.</p>
    </section>
  )
}

function Account() {
  const me = useT((s) => s.me)
  const [error, setError] = useState<string | null>(null)
  async function logout() {
    if (!confirm('tensor에서 로그아웃할까요? 메신저는 그대로 로그인되어 있습니다.')) return
    try {
      await engine.logout()
      navigate('/', { replace: true })
    } catch (e) {
      setError(errorText(e))
    }
  }
  return (
    <section className="card">
      <h3>계정</h3>
      <p className="muted">{me?.name}님으로 로그인했습니다.</p>
      <ErrorText text={error} />
      <button type="button" className="secondary" onClick={() => void logout()}>
        로그아웃
      </button>
      <p className="muted small">tensor {import.meta.env.VITE_APP_VERSION}</p>
    </section>
  )
}

export function SettingsScreen({ cur }: { cur: Current | undefined }) {
  return (
    <div className="page t-page">
      {cur && (
        <>
          <WorkbookSettings key={cur.workbook.id} workbook={cur.workbook} />
          <section className="card menu t-links">
            <button type="button" onClick={() => navigate('/budgets')}>
              예산 정하기
            </button>
            <button type="button" onClick={() => navigate('/items')}>
              항목·차원 관리 (사람·분류·결제수단과 만든 차원)
            </button>
            <button type="button" onClick={() => navigate('/csv')}>
              CSV 내보내기·가져오기
            </button>
          </section>
        </>
      )}
      <Display />
      <Account />
    </div>
  )
}
